import { Select } from 'antd'
import { useFirestore, useFirestoreCollectionData } from 'reactfire'
import { collection, orderBy, query } from 'firebase/firestore'

export function TaxOfficeSelect(props) {
  const firestore = useFirestore()

  const { data: taxOffices } = useFirestoreCollectionData(
    query(
      collection(firestore, 'configs', 'authorities', 'tax-offices'),
      orderBy('name')
    ),
    { idField: 'uid' }
  )

  const options = (taxOffices ?? []).map((office) => ({
    value: office.uid,
    label: `${office.name} (${office.uid}), ${office.address?.city ?? ''}`,
  }))

  return (
    <Select
      allowClear
      showSearch
      optionFilterProp="label"
      options={options}
      {...props}
    />
  )
}
